import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_DARK_MODE_ROLLOUT_EXPERIMENT = defineFcm('dark_mode_rollout_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({ experimentName: undefined })
	.toConfig({
		owner: 'squad-site-platform',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Dark mode',
		description:
			'Maps a global default and/or a country/locale override to the Experiment Service experiment name that ramps ' +
			'dark mode. Configure the global entry to ramp everyone through a single experiment, and/or per-country/per-locale ' +
			'entries in the admin console pointing at their own experiments (e.g. dark_mode_rollout_fr) when a region needs ' +
			'independent rollout percentage tuned separately from the global default. A country/locale override, when set, ' +
			'takes precedence over the global value for that region. No matching entry at any level means dark mode stays ' +
			'disabled.',
		template: {
			experimentName: '',
		},
		supportedGroups: { global: true, countries: true, locales: true },
		deprecated: 'FCM no longer in use — safe to delete after 2026-10-05',
	});
